import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ScheduledReportService extends Service {
	constructor(injector: Injector) {
		super("ScheduledReport", injector);
	}

	// API
	forUserProfile(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForUserProfile/${id}`);
	}
}